<script setup lang="ts">
import { RouterView } from 'vue-router'
import CookieConsent from '@/components/consent/CookieConsent.vue'
</script>

<template>
  <div class="flex flex-col w-full bg-background text-text-primary">
    <!-- First in the DOM so keyboard users reach it first; it is position:fixed, so it takes no layout space. -->
    <CookieConsent />
    <RouterView />
  </div>
</template>
